/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import BN from 'bignumber.js';
import cn from 'classnames';
// TODO: move to utils
import { getDuration } from '../../../../../components/util';
import { formatToken, formatDollars, fromWeiToEther } from '../../../../../helpers/token-helper';
import { TOKEN_OPTIONS, KYL } from '../../../../../constants/blockchain-constants';
import s from '../item.module.scss';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import {
  ColumnTotalStakedAmount,
  ColumnStatus,
  ColumnEstimatedApr,
  ColumnEstimatedDailyRewards,
  ColumnEarnedRewards,
} from '../../../../../components/Stake/column';

const KylItem = ({ isActive, onClick }) => {
  const colors = useGetTheme();

  const {
    stakeBalance,
    estimatedDailyRewards,
    usdPrice = 0,
    apr,
    earnedRewards,
  } = useSelector((state) => ({
    ...state.KYLstake.stake,
    usdPrice: state.basic.currency.USD[KYL],
  }));

  const getWrapBgColor = () => ({ style: { backgroundColor: colors.listAssetBackground } });

  const stakeBalanceInUSD = new BN(stakeBalance).times(usdPrice).toFixed(0, BN.ROUND_DOWN);

  const percentInOMText = `${apr}%`;

  return (
    <div className={cn(s.wrap, { [s.active]: isActive })} {...getWrapBgColor()} onClick={onClick}>
      <ColumnTotalStakedAmount
        title={KYL}
        logoIcon={TOKEN_OPTIONS[KYL].icon}
        token={formatToken(stakeBalance)}
        usdPrice={formatDollars(stakeBalanceInUSD)}
      />
      <ColumnStatus stakeDuration={getDuration(fromWeiToEther(stakeBalance))} />
      <ColumnEstimatedApr percentInOMText={percentInOMText} />
      <ColumnEstimatedDailyRewards
        titleRewardToken={KYL}
        estimatedDailyReward={estimatedDailyRewards}
      />
      <ColumnEarnedRewards
        rewardEarned={formatToken(earnedRewards)}
        titleRewardToken={TOKEN_OPTIONS[KYL].titleRewardToken}
      />
    </div>
  );
};

KylItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default KylItem;
